

























import {
    AssociarVendedorRequest,
    ConsultoresService,
} from "@/services/consultores.service";
import { UsuariosService } from "@/services/usuarios.service";
import Modal from "@/shared/components/modal.vue";
import { required } from "@/shared/validators";
import { Component, Vue } from "vue-property-decorator";

interface UsuarioItem {
  idUsuario: number;
  nome: string;
}

@Component({
  components: {
    Modal,
  },
})
export default class AssociarVendedor extends Vue {
  loading = false;
  idPlano: number | null = null;
  idVendedor: number | null = null;
  usuarios: UsuarioItem[] = [];

  rules = {
    idVendedor: [required()],
  };

  async abrir(idPlano: number) {
    this.idPlano = idPlano;
    this.idVendedor = null;
    await this.carregarUsuariosAtivos();

    const modal = this.$refs.modal as Modal;
    return modal.open();
  }

  fechar() {
    const modal = this.$refs.modal as Modal;
    modal.close(false);
  }

  async confirmar() {
    const form = this.$refs.form as any;
    if (!form.validate() || !this.idPlano || !this.idVendedor) {
      return;
    }

    this.loading = true;
    try {
      const payload: AssociarVendedorRequest = {
        idPlano: this.idPlano,
        idVendedor: this.idVendedor,
      };

      await ConsultoresService.AssociarVendedor(payload);

      const modal = this.$refs.modal as Modal;
      modal.close(true);
    } finally {
      this.loading = false;
    }
  }

  async carregarUsuariosAtivos() {
    const response = await UsuariosService.Lista({
      role: null,
      txtPesquisa: "",
      ativo: true,
      offset: 0,
      limit: 1000,
      order: "nome",
    });

    const lista = Array.isArray(response) ? response : response?.lista || [];

    this.usuarios = lista.map((usuario: any) => ({
      idUsuario: usuario.idUsuario,
      nome: usuario.nome,
    }));
  }
}
